"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupCompanyMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const company_entity_1 = require("./company.entity");
let GroupCompanyMap = class GroupCompanyMap {
    constructor(companyId, groupCompanyId) {
        this.companyId = companyId;
        this.groupCompanyId = groupCompanyId;
    }
};
exports.GroupCompanyMap = GroupCompanyMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], GroupCompanyMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], GroupCompanyMap.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "group_company_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], GroupCompanyMap.prototype, "groupCompanyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company, (company) => company.groupCompanyMaps, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", Object)
], GroupCompanyMap.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company, (company) => company.groupCompanyMaps, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "group_company_id" }),
    tslib_1.__metadata("design:type", Object)
], GroupCompanyMap.prototype, "groupCompany", void 0);
exports.GroupCompanyMap = GroupCompanyMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("group_company_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number])
], GroupCompanyMap);
